<template>
  <div class="d-flex flex-column fill-height">
    <!-- Abaixo de 960px o menu vira gaveta: esta barra e o jeito de abri-la e
         mostra em que painel se esta. -->
    <v-app-bar v-if="isMobile" app flat dense color="white" class="mobile-bar">
      <v-app-bar-nav-icon
        aria-label="Abrir menu"
        @click.stop="drawer = !drawer"
      />
      <v-img
        contain
        max-height="26"
        max-width="132"
        position="left center"
        :src="require('@/assets/icons/connect_logo_bar.svg')"
        alt="Pitch Connect"
      />
    </v-app-bar>

    <!-- Desktop largo: aberto e fixo. Notebook pequeno/tablet deitado (960 a
         1263px): fixo, mas comeca so com os icones. Celular e tablet em pe:
         gaveta sobreposta, fechada ate o usuario abrir. -->
    <v-navigation-drawer
      v-model="drawer"
      app
      :mini-variant="mini && !isMobile"
      :permanent="!isMobile"
      :temporary="isMobile"
      clipped
      class="pb-0"
    >
      <v-list class="transparent pt-0 pb-0" nav>
        <v-list-item class="mt-2" style="height: 64px">
          <v-img
            @click="toggleMini"
            contain
            height="32"
            :src="
              mini && !isMobile
                ? require('@/assets/images/logo_pitch.webp')
                : require('@/assets/icons/connect_logo_bar.svg')
            "
            class="cursor-pointer"
            :alt="
              isMobile
                ? 'Pitch Connect'
                : mini
                ? 'Expandir menu'
                : 'Recolher menu'
            "
          />
        </v-list-item>
      </v-list>
      <v-divider class="ma-0 pa-0"></v-divider>

      <v-list class="transparent mt-4" nav>
        <div v-for="(item, i) in routes" :key="i">
          <router-link
            v-if="item.path"
            v-slot="{ href, navigate }"
            :to="item.path"
            custom
          >
            <v-tooltip right :disabled="!mini || isMobile">
              <template v-slot:activator="{ on, attrs }">
                <v-list-item
                  link
                  v-bind="attrs"
                  v-on="on"
                  class="mb-1 nav-item"
                  :input-value="isActive(item.path)"
                  color="#9923CD"
                  :href="href"
                  @click="navigate"
                  dense
                >
                  <v-list-item-icon>
                    <i
                      class="fi nav-icon"
                      :class="item.icon"
                      aria-hidden="true"
                    ></i>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.name"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <span>{{ item.name }}</span>
            </v-tooltip>
          </router-link>

          <v-list-group
            v-else
            :key="item.name"
            no-action
            sub-group
            class="mb-1"
          >
            <v-list-item-icon>
              <i class="fi nav-icon" :class="item.icon" aria-hidden="true"></i>
            </v-list-item-icon>

            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title v-text="item.name"></v-list-item-title>
              </v-list-item-content>
            </template>

            <router-link
              v-for="(subItem, index) in item.children"
              :key="index"
              :to="subItem.path"
              v-slot="{ href, navigate }"
              custom
            >
              <v-list-item
                nav
                :href="href"
                @click="navigate"
                class="pl-8"
                dense
              >
                <v-list-item-icon>
                  <i
                    class="fi nav-icon"
                    :class="subItem.icon"
                    aria-hidden="true"
                  ></i>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="subItem.name"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </router-link>
          </v-list-group>
        </div>
      </v-list>

      <v-divider class="ma-0 pa-0"></v-divider>

      <template v-slot:append>
        <v-divider class="ma-0 pa-0"></v-divider>

        <v-list class="transparent py-2" nav>
          <router-link
            v-for="(item, i) in secondaryRoutes"
            v-slot="{ href, navigate }"
            :to="item.path"
            :key="i"
            custom
          >
            <v-tooltip right :disabled="!mini || isMobile">
              <template v-slot:activator="{ on, attrs }">
                <v-list-item
                  link
                  v-bind="attrs"
                  v-on="on"
                  class="nav-item"
                  :input-value="isActive(item.path)"
                  color="#9923CD"
                  :href="href"
                  @click="navigate"
                  dense
                >
                  <v-list-item-icon>
                    <v-badge
                      v-if="item.count"
                      bordered
                      overlap
                      color="red"
                      :content="item.count > 99 ? '99+' : item.count"
                    >
                      <i
                        class="fi nav-icon"
                        :class="item.icon"
                        aria-hidden="true"
                      ></i>
                    </v-badge>
                    <i
                      v-else
                      class="fi nav-icon"
                      :class="item.icon"
                      aria-hidden="true"
                    ></i>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.name"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <span>{{ item.name }}</span>
            </v-tooltip>
          </router-link>

          <v-divider class="my-2"></v-divider>

          <router-link to="/meu-perfil" custom v-slot="{ href, navigate }">
            <v-tooltip right :disabled="!mini || isMobile">
              <template v-slot:activator="{ on, attrs }">
                <v-list-item
                  link
                  v-bind="attrs"
                  v-on="on"
                  :href="href"
                  @click="navigate"
                  dense
                >
                  <v-list-item-icon>
                    <v-avatar size="32">
                      <v-img
                        alt="avatar"
                        src="@/assets/icons/tempAvatar.svg"
                      ></v-img>
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      (user && user.name) || "Meu perfil"
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      profileName
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <span>Meu perfil</span>
            </v-tooltip>
          </router-link>

          <v-tooltip right :disabled="!mini || isMobile">
            <template v-slot:activator="{ on, attrs }">
              <v-list-item link v-bind="attrs" v-on="on" @click="logoff" dense>
                <v-list-item-icon>
                  <i
                    class="fi fi-rr-sign-out-alt nav-icon"
                    aria-hidden="true"
                  ></i>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="'Logout'"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <span>Logout</span>
          </v-tooltip>
        </v-list>
      </template>
    </v-navigation-drawer>
    <div class="d-flex flex-column fill-height">
      <v-main class="background">
        <slot />
      </v-main>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import api from "@/shared/api";
import { MESSAGES_UNREAD_REFRESH_EVENT } from "@/shared/messagesEvents";
import { PRIMARY_NAVIGATION, SECONDARY_NAVIGATION } from "@/shared/navigation";

export default {
  name: "ApplicationView",
  components: {},
  data() {
    const width = typeof window === "undefined" ? 1400 : window.innerWidth;
    return {
      // 960-1263px: comeca recolhido para sobrar espaco para tabelas e
      // dashboards; da para abrir clicando no logo.
      mini: width >= 960 && width < 1264,
      // No celular a gaveta comeca fechada.
      drawer: width >= 960,
      supportUnread: 0,
      supportUnreadTimer: null,
    };
  },
  mounted() {
    // Card 17trt6jbffe: badge de Mensagens a cada 60 s e quando a tela de
    // Mensagens avisa que leu/respondeu.
    this.refreshSupportUnread();
    this.supportUnreadTimer = window.setInterval(
      this.refreshSupportUnread,
      60000
    );
    window.addEventListener(
      MESSAGES_UNREAD_REFRESH_EVENT,
      this.refreshSupportUnread
    );
  },
  beforeDestroy() {
    window.clearInterval(this.supportUnreadTimer);
    window.removeEventListener(
      MESSAGES_UNREAD_REFRESH_EVENT,
      this.refreshSupportUnread
    );
  },
  watch: {
    // No celular, escolher uma tela fecha a gaveta e mostra a pagina.
    $route() {
      if (this.isMobile) this.drawer = false;
    },
    // Girar o tablet ou redimensionar a janela: volta ao estado da faixa nova.
    isMobile(mobile) {
      this.drawer = !mobile;
    },
  },
  computed: {
    ...mapState(["user"]),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    // Menu filtrado pelo perfil (shared/navigation.js).
    routes() {
      return PRIMARY_NAVIGATION.filter((item) => this.$can(item.permission));
    },
    secondaryRoutes() {
      return SECONDARY_NAVIGATION.filter((item) =>
        this.$can(item.permission)
      ).map((item) => ({
        ...item,
        count: item.countKey ? this[item.countKey] : undefined,
      }));
    },
    profileName() {
      return this.$store.getters.access?.profile?.name || "Sem perfil";
    },
  },

  methods: {
    ...mapActions(["setUser", "setToken", "setAccess"]),
    clearService() {
      this.$router.push({ path: "/home" });
    },

    logoff() {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");
      this.setUser(null);
      this.setToken(null);
      this.setAccess(null);
      this.$router.push({
        path: "/sign-in",
      });
    },

    async refreshSupportUnread() {
      // Badge so para quem ve Mensagens: sem a permissao a API responde 403.
      if (!this.$can("messages.list")) return;
      if (
        typeof document !== "undefined" &&
        document.visibilityState === "hidden"
      ) {
        return;
      }
      try {
        const { data } = await api.getSupportUnread();
        // COUNT chega como texto: converter (nao e id).
        this.supportUnread = Number(data?.support) || 0;
      } catch {
        // Badge desatualizado nao atrapalha a navegacao.
      }
    },

    // Destaca a tela aberta (inclusive as internas, ex.: /alunos/123).
    isActive(path) {
      const current = this.$route.path;
      return current === path || current.startsWith(`${path}/`);
    },

    // No celular o logo nao recolhe (a gaveta fecha pelo fundo ou ao navegar).
    toggleMini() {
      if (!this.isMobile) this.mini = !this.mini;
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.mobile-bar {
  border-bottom: 1px solid rgba(35, 26, 46, 0.08) !important;
}

/* Icones da barra lateral: UIcons regular rounded, um traco so. A cor segue
   o texto do item, entao a tela aberta fica violeta junto com o rotulo. */
.nav-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  font-size: 18px;
  line-height: 1;
  color: #6b6472;
  transition: color 0.15s ease;
}
.nav-item.v-list-item--active .nav-icon,
.nav-item:hover .nav-icon {
  color: #9923cd;
}
.nav-item.v-list-item--active .v-list-item__title {
  font-weight: 600;
}
@media (prefers-reduced-motion: reduce) {
  .nav-icon {
    transition: none;
  }
}
</style>
